import { useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './AddConfirmToast.module.css'

interface AddConfirmToastProps {
  action: 'add-collection' | 'add-wantlist'
  releaseLabel?: string
  onConfirm: (dontShowAgain: boolean) => void
  onCancel: () => void
}

export function AddConfirmToast({ action, releaseLabel, onConfirm, onCancel }: AddConfirmToastProps) {
  const [dontShowAgain, setDontShowAgain] = useState(true)
  const isCollection = action === 'add-collection'

  const target = isCollection ? 'Discogs Collection' : 'Discogs Wantlist'
  const title = isCollection ? 'Adding to your Discogs Collection' : 'Adding to your Discogs Wantlist'

  return createPortal(
    <div className={styles.wrap} role="dialog" aria-label={title}>
      <div className={styles.card}>
        <div className={styles.head}>
          <span className={styles.eyebrowIcon}>
            <i className="bi bi-arrow-left-right" />
          </span>
          <span className={styles.eyebrow}>Two-way sync</span>
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>
          {releaseLabel ? <><span className={styles.bodyStrong}>{releaseLabel}</span> is about to be added to your </> : 'This release will be added to your '}
          <span className={styles.bodyStrong}>{target}</span>. The change writes through to Discogs immediately — same as if you added it on discogs.com.
        </p>
        <label className={styles.checkRow}>
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          />
          Don&apos;t show this again for adds
        </label>
        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.confirmBtn} onClick={() => onConfirm(dontShowAgain)} autoFocus>
            Yes, add it
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
